export default __webpack_public_path__ + "37d2217c4cb01438eb3455034d7290a4.png";